import type { AuthConsentRecord } from "./authConsents";

const KEY = "pending-auth-consent-v1";

export type PendingAuthConsent = {
  consents: AuthConsentRecord[];
  marketingConsent: boolean;
  source: string;
};

export function savePendingAuthConsent(consent: PendingAuthConsent) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(consent));
  } catch {
    // Ignore storage failures; the user can update consents later in settings.
  }
}

export function loadPendingAuthConsent(): PendingAuthConsent | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as PendingAuthConsent) : null;
  } catch {
    return null;
  }
}

export function clearPendingAuthConsent() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // Ignore storage failures.
  }
}
